var map = {
	"./client2-01.png": 6450,
	"./client2-02.png": 502,
	"./client2-03.png": 278,
	"./client2-04.png": 2907,
	"./client2-05.png": 5595,
	"./client2-06.png": 9650,
	"./client2-07.png": 2703,
	"./client2-08.png": 2017,
	"./client2-09.png": 2612,
	"./client2-10.png": 4085,
	"./client2-11.png": 6038,
	"./client2-12.png": 7681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 413;